import * as irctcCreateAccountActions from './../actions/irctcCreateAccountActions';
import { COUNTRIES_LIST, IRCTC_CREATE_ACCOUNT_COMPONENTS, LANGUAGE_LIST } from '../utils/RailsSEOConstants';

export const irctcCreateAccountInitialState = {
  componentToShow: IRCTC_CREATE_ACCOUNT_COMPONENTS.inputForm,
  userName: '',
  userEmail: '',
  mobileNumber: '',
  showErrorCreateAccount: '',
  userNameErrorMessage: '',
  userEmailErrorMessage: '',
  mobileNumberErrorMessage: '',
  password: null,
  selectedSecurityQuestion: null,
  securityQuestionList: null,
  securityAnswer: null,
  firstName: null,
  lastName: null,
  selectedDate: null,
  occupationList: null,
  selectedOccupation: null,
  selectedGender: null,
  selectedMaritalStatus: null,
  preferredLanguageList: LANGUAGE_LIST,
  selectedPreferredLanguage: null,
  residentialAddress: null,
  alternateContact: null,
  countryList: COUNTRIES_LIST,
  selectedCountry: null,
  pinCode: null,
  pinCodeErrorMessage: '',
  cityList: null,
  stateList: null,
  postOfficeList: null,
  officePostOffice: null,
  officeCity: null,
  officeRegionalState: null,
  emailCode: null,
  smsCode: null,
  showErrorOtpPage: false,
  showAddressInfoOnMView: false,
  showPersonalInfoOnMView: false,
  showAccountInfoOnMView: false,
  scrollToErrorElement: ''
};

export const irctcCreateAccountReducer = (state, action) => {
  if (typeof action !== 'object') {
    return state;
  }
  switch (action.type) {
    case irctcCreateAccountActions.ACTION_SET_COMPONENT_CREATE_ACCOUNT: {
      return {
        ...state,
        componentToShow: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_USERNAME_CREATE_ACCOUNT: {
      return {
        ...state,
        userName: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_USERMAIL_CREATE_ACCOUNT: {
      return {
        ...state,
        userEmail: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_MOBILE_NUMBER_CREATE_ACCOUNT: {
      return {
        ...state,
        mobileNumber: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SHOW_ERROR_CREATE_ACCOUNT: {
      return {
        ...state,
        showErrorCreateAccount: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_USERNAME_ERROR_MSG_CREATE_ACCOUNT: {
      return {
        ...state,
        userNameErrorMessage: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_USER_EMAIL_ERROR_MSG_CREATE_ACCOUNT: {
      return {
        ...state,
        userEmailErrorMessage: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_MOBILE_NUMBER_ERROR_MSG_CREATE_ACCOUNT: {
      return {
        ...state,
        mobileNumberErrorMessage: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_PASSWORD_CREATE_ACCOUNT: {
      return {
        ...state,
        password: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_QUESTION_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedSecurityQuestion: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SECURITY_QUESTION_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        securityQuestionList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SECURITY_ANSWER_CREATE_ACCOUNT: {
      return {
        ...state,
        securityAnswer: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_FIRST_NAME_CREATE_ACCOUNT: {
      return {
        ...state,
        firstName: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_LAST_NAME_CREATE_ACCOUNT: {
      return {
        ...state,
        lastName: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_DATE_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedDate: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_OCCUPATION_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        occupationList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_OCCUPATION_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedOccupation: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_GENDER_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedGender: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_MARITAL_STATUS_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedMaritalStatus: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_PREFERRED_LANGUAGE_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        preferredLanguageList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_PREFERRED_LANGUAGE_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedPreferredLanguage: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_RESIDENTIAL_ADDRESS_CREATE_ACCOUNT: {
      return {
        ...state,
        residentialAddress: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_ALTERNATE_CONTACT_CREATE_ACCOUNT: {
      return {
        ...state,
        alternateContact: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_COUNTRY_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        countryList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SELECTED_COUNTRY_CREATE_ACCOUNT: {
      return {
        ...state,
        selectedCountry: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_PINCODE_CREATE_ACCOUNT: {
      return {
        ...state,
        pinCode: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_PINCODE_ERR_MSG_CREATE_ACCOUNT: {
      return {
        ...state,
        pinCodeErrorMessage: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_CITY_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        cityList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_STATE_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        stateList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_POST_OFFICE_LIST_CREATE_ACCOUNT: {
      return {
        ...state,
        postOfficeList: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_OFFICE_POST_OFFICE_CREATE_ACCOUNT: {
      return {
        ...state,
        officePostOffice: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_OFFICE_CITY_CREATE_ACCOUNT: {
      return {
        ...state,
        officeCity: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_OFFICE_REGIONAL_STATE_CREATE_ACCOUNT: {
      return {
        ...state,
        officeRegionalState: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_EMAIL_CODE_CREATE_ACCOUNT: {
      return {
        ...state,
        emailCode: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SMS_CODE_CREATE_ACCOUNT: {
      return {
        ...state,
        smsCode: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SHOW_ERROR_OTP_PAGE: {
      return {
        ...state,
        showErrorOtpPage: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SHOW_ADDRESS_INFO_MVIEW: {
      return {
        ...state,
        showAddressInfoOnMView: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SHOW_PERSONAL_INFO_MVIEW: {
      return {
        ...state,
        showPersonalInfoOnMView: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SET_SHOW_ACCOUNT_SETUP_MVIEW: {
      return {
        ...state,
        showAccountInfoOnMView: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_SCROLL_TO_ERROR_CREATE_ACCOUNT: {
      return {
        ...state,
        showAddressInfoOnMView: true,
        showPersonalInfoOnMView: true,
        showAccountInfoOnMView: true,
        scrollToErrorElement: action.data
      };
    }
    case irctcCreateAccountActions.ACTION_RESET_SCROLL_ERROR_ELEMENT: {
      return {
        ...state,
        scrollToErrorElement: ''
      };
    }
    default: {
      return state;
    }
  }
};
